import { render } from "./serviceCard.vue?vue&type=template&id=3d82806c&scoped=true"
import script from "./serviceCard.vue?vue&type=script&lang=js"
export * from "./serviceCard.vue?vue&type=script&lang=js"

import "./serviceCard.vue?vue&type=style&index=0&id=3d82806c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d82806c"]])

export default __exports__